/**
 * 中国行政区划代码映射（前6位 → 地区名称）
 * 数据来源: GB/T 2260 中华人民共和国行政区划代码
 */
export const REGION_CODES: Record<string, string> = {
  // === 直辖市 ===
  '11': '北京市',
  '1101': '北京市市辖区',
  '110101': '北京市东城区',
  '110102': '北京市西城区',
  '110105': '北京市朝阳区',
  '110106': '北京市丰台区',
  '110107': '北京市石景山区',
  '110108': '北京市海淀区',
  '110109': '北京市门头沟区',
  '110111': '北京市房山区',
  '110112': '北京市通州区',
  '110113': '北京市顺义区',
  '110114': '北京市昌平区',
  '110115': '北京市大兴区',
  '110116': '北京市怀柔区',
  '110117': '北京市平谷区',
  '110118': '北京市密云区',
  '110119': '北京市延庆区',

  '12': '天津市',
  '1201': '天津市市辖区',
  '120101': '天津市和平区',
  '120102': '天津市河东区',
  '120103': '天津市河西区',
  '120104': '天津市南开区',
  '120105': '天津市河北区',
  '120106': '天津市红桥区',
  '120110': '天津市东丽区',
  '120111': '天津市西青区',
  '120112': '天津市津南区',
  '120113': '天津市北辰区',
  '120114': '天津市武清区',
  '120115': '天津市宝坻区',
  '120116': '天津市滨海新区',
  '120117': '天津市宁河区',
  '120118': '天津市静海区',
  '120119': '天津市蓟州区',

  '31': '上海市',
  '3101': '上海市市辖区',
  '310101': '上海市黄浦区',
  '310104': '上海市徐汇区',
  '310105': '上海市长宁区',
  '310106': '上海市静安区',
  '310107': '上海市普陀区',
  '310109': '上海市虹口区',
  '310110': '上海市杨浦区',
  '310112': '上海市闵行区',
  '310113': '上海市宝山区',
  '310114': '上海市嘉定区',
  '310115': '上海市浦东新区',
  '310116': '上海市金山区',
  '310117': '上海市松江区',
  '310118': '上海市青浦区',
  '310120': '上海市奉贤区',
  '310151': '上海市崇明区',

  '50': '重庆市',
  '5001': '重庆市市辖区',
  '500101': '重庆市万州区',
  '500102': '重庆市涪陵区',
  '500103': '重庆市渝中区',
  '500104': '重庆市大渡口区',
  '500105': '重庆市江北区',
  '500106': '重庆市沙坪坝区',
  '500107': '重庆市九龙坡区',
  '500108': '重庆市南岸区',
  '500109': '重庆市北碚区',
  '500110': '重庆市綦江区',
  '500111': '重庆市大足区',
  '500112': '重庆市渝北区',
  '500113': '重庆市巴南区',
  '500114': '重庆市黔江区',
  '500115': '重庆市长寿区',
  '500116': '重庆市江津区',
  '500117': '重庆市合川区',
  '500118': '重庆市永川区',
  '500119': '重庆市南川区',
  '500120': '重庆市璧山区',
  '500151': '重庆市铜梁区',
  '500152': '重庆市潼南区',
  '500153': '重庆市荣昌区',
  '500154': '重庆市开州区',
  '500155': '重庆市梁平区',
  '500156': '重庆市武隆区',

  // === 省份 ===
  '13': '河北省',
  '1301': '石家庄市',
  '1302': '唐山市',
  '1303': '秦皇岛市',
  '1304': '邯郸市',
  '1305': '邢台市',
  '1306': '保定市',
  '1307': '张家口市',
  '1308': '承德市',
  '1309': '沧州市',
  '1310': '廊坊市',
  '1311': '衡水市',

  '14': '山西省',
  '1401': '太原市',
  '1402': '大同市',
  '1403': '阳泉市',
  '1404': '长治市',
  '1405': '晋城市',
  '1406': '朔州市',
  '1407': '晋中市',
  '1408': '运城市',
  '1409': '忻州市',
  '1410': '临汾市',
  '1411': '吕梁市',

  '15': '内蒙古自治区',
  '1501': '呼和浩特市',
  '1502': '包头市',
  '1503': '乌海市',
  '1504': '赤峰市',
  '1505': '通辽市',
  '1506': '鄂尔多斯市',
  '1507': '呼伦贝尔市',
  '1508': '巴彦淖尔市',
  '1509': '乌兰察布市',

  '21': '辽宁省',
  '2101': '沈阳市',
  '2102': '大连市',
  '2103': '鞍山市',
  '2104': '抚顺市',
  '2105': '本溪市',
  '2106': '丹东市',
  '2107': '锦州市',
  '2108': '营口市',
  '2109': '阜新市',
  '2110': '辽阳市',
  '2111': '盘锦市',
  '2112': '铁岭市',
  '2113': '朝阳市',
  '2114': '葫芦岛市',

  '22': '吉林省',
  '2201': '长春市',
  '2202': '吉林市',
  '2203': '四平市',
  '2204': '辽源市',
  '2205': '通化市',
  '2206': '白山市',
  '2207': '松原市',
  '2208': '白城市',

  '23': '黑龙江省',
  '2301': '哈尔滨市',
  '2302': '齐齐哈尔市',
  '2303': '鸡西市',
  '2304': '鹤岗市',
  '2305': '双鸭山市',
  '2306': '大庆市',
  '2307': '伊春市',
  '2308': '佳木斯市',
  '2309': '七台河市',
  '2310': '牡丹江市',
  '2311': '黑河市',
  '2312': '绥化市',

  '32': '江苏省',
  '3201': '南京市',
  '3202': '无锡市',
  '3203': '徐州市',
  '3204': '常州市',
  '3205': '苏州市',
  '3206': '南通市',
  '3207': '连云港市',
  '3208': '淮安市',
  '3209': '盐城市',
  '3210': '扬州市',
  '3211': '镇江市',
  '3212': '泰州市',
  '3213': '宿迁市',

  '33': '浙江省',
  '3301': '杭州市',
  '3302': '宁波市',
  '3303': '温州市',
  '3304': '嘉兴市',
  '3305': '湖州市',
  '3306': '绍兴市',
  '3307': '金华市',
  '3308': '衢州市',
  '3309': '舟山市',
  '3310': '台州市',
  '3311': '丽水市',

  '34': '安徽省',
  '3401': '合肥市',
  '3402': '芜湖市',
  '3403': '蚌埠市',
  '3404': '淮南市',
  '3405': '马鞍山市',
  '3406': '淮北市',
  '3407': '铜陵市',
  '3408': '安庆市',
  '3409': '黄山市',
  '3410': '滁州市',
  '3411': '阜阳市',
  '3412': '宿州市',
  '3413': '六安市',
  '3414': '亳州市',
  '3415': '池州市',
  '3416': '宣城市',

  '35': '福建省',
  '3501': '福州市',
  '3502': '厦门市',
  '3503': '莆田市',
  '3504': '三明市',
  '3505': '泉州市',
  '3506': '漳州市',
  '3507': '南平市',
  '3508': '龙岩市',
  '3509': '宁德市',

  '36': '江西省',
  '3601': '南昌市',
  '3602': '景德镇市',
  '3603': '萍乡市',
  '3604': '九江市',
  '3605': '新余市',
  '3606': '鹰潭市',
  '3607': '赣州市',
  '3608': '吉安市',
  '3609': '宜春市',
  '3610': '抚州市',
  '3611': '上饶市',

  '37': '山东省',
  '3701': '济南市',
  '3702': '青岛市',
  '3703': '淄博市',
  '3704': '枣庄市',
  '3705': '东营市',
  '3706': '烟台市',
  '3707': '潍坊市',
  '3708': '济宁市',
  '3709': '泰安市',
  '3710': '威海市',
  '3711': '日照市',
  '3712': '临沂市',
  '3713': '德州市',
  '3714': '聊城市',
  '3715': '滨州市',
  '3716': '菏泽市',

  '41': '河南省',
  '4101': '郑州市',
  '4102': '开封市',
  '4103': '洛阳市',
  '4104': '平顶山市',
  '4105': '安阳市',
  '4106': '鹤壁市',
  '4107': '新乡市',
  '4108': '焦作市',
  '4109': '濮阳市',
  '4110': '许昌市',
  '4111': '漯河市',
  '4112': '三门峡市',
  '4113': '南阳市',
  '4114': '商丘市',
  '4115': '信阳市',
  '4116': '周口市',
  '4117': '驻马店市',

  '42': '湖北省',
  '4201': '武汉市',
  '4202': '黄石市',
  '4203': '十堰市',
  '4205': '宜昌市',
  '4206': '襄阳市',
  '4207': '鄂州市',
  '4208': '荆门市',
  '4209': '孝感市',
  '4210': '荆州市',
  '4211': '黄冈市',
  '4212': '咸宁市',
  '4213': '随州市',

  '43': '湖南省',
  '4301': '长沙市',
  '4302': '株洲市',
  '4303': '湘潭市',
  '4304': '衡阳市',
  '4305': '邵阳市',
  '4306': '岳阳市',
  '4307': '常德市',
  '4308': '张家界市',
  '4309': '益阳市',
  '4310': '郴州市',
  '4311': '永州市',
  '4312': '怀化市',
  '4313': '娄底市',

  '44': '广东省',
  '4401': '广州市',
  '4402': '韶关市',
  '4403': '深圳市',
  '4404': '珠海市',
  '4405': '汕头市',
  '4406': '佛山市',
  '4407': '江门市',
  '4408': '湛江市',
  '4409': '茂名市',
  '4412': '肇庆市',
  '4413': '惠州市',
  '4414': '梅州市',
  '4415': '汕尾市',
  '4416': '河源市',
  '4417': '阳江市',
  '4418': '清远市',
  '4419': '东莞市',
  '4420': '中山市',
  '4451': '潮州市',
  '4452': '揭阳市',
  '4453': '云浮市',

  '45': '广西壮族自治区',
  '4501': '南宁市',
  '4502': '柳州市',
  '4503': '桂林市',
  '4504': '梧州市',
  '4505': '北海市',
  '4506': '防城港市',
  '4507': '钦州市',
  '4508': '贵港市',
  '4509': '玉林市',
  '4510': '百色市',
  '4511': '贺州市',
  '4512': '河池市',
  '4513': '来宾市',
  '4514': '崇左市',

  '46': '海南省',
  '4601': '海口市',
  '4602': '三亚市',
  '4603': '三沙市',
  '4604': '儋州市',

  '51': '四川省',
  '5101': '成都市',
  '5103': '自贡市',
  '5104': '攀枝花市',
  '5105': '泸州市',
  '5106': '德阳市',
  '5107': '绵阳市',
  '5108': '广元市',
  '5109': '遂宁市',
  '5110': '内江市',
  '5111': '乐山市',
  '5113': '南充市',
  '5114': '眉山市',
  '5115': '宜宾市',
  '5116': '广安市',
  '5117': '达州市',
  '5118': '雅安市',
  '5119': '巴中市',
  '5120': '资阳市',

  '52': '贵州省',
  '5201': '贵阳市',
  '5202': '六盘水市',
  '5203': '遵义市',
  '5204': '安顺市',
  '5205': '毕节市',
  '5206': '铜仁市',

  '53': '云南省',
  '5301': '昆明市',
  '5303': '曲靖市',
  '5304': '玉溪市',
  '5305': '保山市',
  '5306': '昭通市',
  '5307': '丽江市',
  '5308': '普洱市',
  '5309': '临沧市',

  '54': '西藏自治区',
  '5401': '拉萨市',
  '5402': '日喀则市',
  '5403': '昌都市',
  '5404': '林芝市',
  '5405': '山南市',
  '5406': '那曲市',

  '61': '陕西省',
  '6101': '西安市',
  '6102': '铜川市',
  '6103': '宝鸡市',
  '6104': '咸阳市',
  '6105': '渭南市',
  '6106': '延安市',
  '6107': '汉中市',
  '6108': '榆林市',
  '6109': '安康市',
  '6110': '商洛市',

  '62': '甘肃省',
  '6201': '兰州市',
  '6202': '嘉峪关市',
  '6203': '金昌市',
  '6204': '白银市',
  '6205': '天水市',
  '6206': '武威市',
  '6207': '张掖市',
  '6208': '平凉市',
  '6209': '酒泉市',
  '6210': '庆阳市',
  '6211': '定西市',
  '6212': '陇南市',

  '63': '青海省',
  '6301': '西宁市',
  '6302': '海东市',

  '64': '宁夏回族自治区',
  '6401': '银川市',
  '6402': '石嘴山市',
  '6403': '吴忠市',
  '6404': '固原市',
  '6405': '中卫市',

  '65': '新疆维吾尔自治区',
  '6501': '乌鲁木齐市',
  '6502': '克拉玛依市',
  '6504': '吐鲁番市',
  '6505': '哈密市',

  // === 特别行政区 ===
  '81': '香港特别行政区',
  '82': '澳门特别行政区',
  // 台湾地区
  '83': '台湾省',
};

/**
 * 根据前6位地区码查找地区名称
 * 优先匹配6位（区县级），再匹配4位（地市级），最后2位（省级）
 */
export function lookupRegion(code: string): string | null {
  // 精确匹配
  if (REGION_CODES[code]) return REGION_CODES[code];
  // 前4位
  const prefix4 = code.slice(0, 4);
  if (REGION_CODES[prefix4]) return REGION_CODES[prefix4];
  // 前2位
  const prefix2 = code.slice(0, 2);
  if (REGION_CODES[prefix2]) return REGION_CODES[prefix2];
  return null;
}
